<template>
  <v-container fluid>
    <v-row class="pb-0" dense>
      <v-col :cols="5">
        <TimePickerField
          v-model="startTime"
          :rules="startTimeRules"
          label="Shift Start Time"
          @input="update"
        />
      </v-col>
      <v-spacer></v-spacer>
      <v-col :cols="4">
        <v-btn depressed color="primary" @click="addBreak">Add Break</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <BreaksAssignment
        v-model="breaks"
        :startTime="startTime"
        :startTimeRules="breakStartRules"
        :endTimeRules="breakEndRules"
        v-on:remove="removeBreak"
        v-on:input="update"/>
    </v-row>
  </v-container>
</template>

<script>
import findIndex from 'lodash/findIndex';

import BreaksAssignment from '@/components/approvals/BreaksAssignment.vue';
import TimePickerField from '@/components/time/TimePickerField.vue';
import isEqual from 'date-fns/isEqual';
import isAfter from 'date-fns/isAfter';
import DateTimeUtil from '../../util/date-time-util';

export default {
  name: 'DurationWorkScheduleAssignment',

  props: {
    value: Object,
  },

  components: {
    BreaksAssignment,
    TimePickerField,
  },

  data() {
    return {
      startTime: this.value.startTime,
      startTimeRules: [(time) => !!time || 'Field is required'],
      breakStartRules: [(time) => {
        const start = DateTimeUtil.getHours(this.startTime);
        const breakStart = DateTimeUtil.getHoursFromFormatted(time);
        return isEqual(start, breakStart) || isAfter(breakStart, start) || 'Break must start after the shift';
      }],
      breakEndRules: [],
      breaks: this.value.breaks,
    };
  },

  methods: {
    addBreak() {
      this.breaks.push({ id: this.breaks.length + 1, startTime: null, endTime: null });
    },

    removeBreak(id) {
      const idx = findIndex(this.breaks, (b) => b.id === id);
      this.breaks.splice(idx, 1);
      this.update();
    },

    update() {
      this.$emit('input', { startTime: this.startTime, breaks: this.breaks });
    },
  },

};
</script>

<style scoped>

</style>
